import React from 'react';
import { useLocation } from 'react-router-dom';
import { TABLE_OF_CONTENTS_BY_TAB_ID } from '../../constants';
import { TocContainer, TocTitle } from '../../styles';
import { TocGroupSection } from './TocGroupSection';

interface TableOfContentsProps {
  selectedTabId: string;
}

export function TableOfContents({ selectedTabId }: TableOfContentsProps) {
  const { pathname, hash } = useLocation();
  const groups = TABLE_OF_CONTENTS_BY_TAB_ID[selectedTabId] ?? [];

  if (groups.length === 0) {
    return null;
  }

  return (
    <TocContainer>
      <TocTitle variant="h6">Table of contents</TocTitle>
      {groups.map((group, groupIndex) => (
        <TocGroupSection
          key={`${group.heading}-${groupIndex}`}
          group={group}
          pathname={pathname}
          hash={hash}
        />
      ))}
    </TocContainer>
  );
}
